(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/take', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/take'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.take, global.convert);
    global.take = mod.exports;
  }
})(this, function (exports, _take2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.take = undefined;

  var _take3 = _interopRequireDefault(_take2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Creates a slice of array with <code>n</code> elements taken from the beginning.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {number} [n=1] Number of elements to take from the beginning of the array.
   * @return {Object} Returns the updated object.
   * @example take({ nested: { prop: [1, 2, 3, 4] } }, 'nested.prop', 2) // => { nested: { prop: [1, 2] } }
   * @see {@link https://lodash.com/docs#take|lodash.take} for more information.
   * @since 0.3.0
   */
  var take = (0, _convert.convert)(_take3.default);
  exports.take = take;
  exports.default = take;
});